import { ENewbuildingBookingActionTypes, TNewbuildingBookingActions } from '../../actions/newbuildingBooking';
import { EBookingStatus, INewbuildingBookingState } from '../../types/newbuildingBooking';

export const DEFAULT_STATE: INewbuildingBookingState = {
  isConfirmOpen: false,
  isEnabled: false,
  landingUrl: '',
  profitbaseUrl: '',
  status: EBookingStatus.Initial,
};

export const newbuildingBookingReducer = (
  state: INewbuildingBookingState = DEFAULT_STATE,
  action: TNewbuildingBookingActions,
): INewbuildingBookingState => {
  switch (action.type) {
    case ENewbuildingBookingActionTypes.CloseConfirm:
      return {
        ...state,
        isConfirmOpen: false,
        status: EBookingStatus.Initial,
      };

    case ENewbuildingBookingActionTypes.CloseSuccess:
      return {
        ...state,
        isConfirmOpen: false,
      };

    case ENewbuildingBookingActionTypes.OpenConfirm:
      return {
        ...state,
        isConfirmOpen: true,
      };

    case ENewbuildingBookingActionTypes.SetBookingFailure:
      return {
        ...state,
        status: EBookingStatus.Failure,
      };

    case ENewbuildingBookingActionTypes.SetBookingLoading:
      return {
        ...state,
        status: EBookingStatus.Loading,
      };

    case ENewbuildingBookingActionTypes.SetBookingSuccess:
      return {
        ...state,
        status: EBookingStatus.Success,
        profitbaseUrl: action.payload,
      };

    default:
      return state;
  }
};
